import { PayrollCardOpeningApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const PayrollCardOpeningApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <PayrollCardOpeningApplication isEdit={isEdit} isCopy={isCopy}/>
);
